import { CommonModule } from '@angular/common';
import { Component, TemplateRef, ViewChild } from '@angular/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { SpinnerComponent } from "../../layout/spinner/spinner.component";
import { ErrorComponent } from "../../layout/error/error.component";
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { environment } from '../../../../environments/environment'
import { CarService } from 'src/app/services/car/car.service';
import { UploadComponent } from "../../layout/upload/upload.component";
import { MarksService } from 'src/app/services/marks/marks.service';

@Component({
  selector: 'app-cars',
  imports: [CommonModule, DragDropModule, SpinnerComponent, ErrorComponent, FormsModule, ReactiveFormsModule, UploadComponent],
  templateUrl: './cars.component.html',
  styleUrl: './cars.component.css'
})

export class CarsComponent {

  data: any[] = []
  load = false
  loadUpdate = false
  url = environment.apiDomain
  error = false
  selected: any = null;
  isEdit = false
  editBtnLoad = false
  @ViewChild('formModal') formModalTemplate!: TemplateRef<any>;
  form: FormGroup;
  loadSave = false

  marks: any
  loadMark = false



  constructor(
    private CarService: CarService,
    private MarksService: MarksService,
    private ToastrService: ToastrService,
    private modalService: NgbModal,
    private fb: FormBuilder,
  ){
    this.get()
    this.getMarks()
    this.form = this.fb.group({
      id: [null],
      name: null,
      image: null,
      markid: null
    });

  }


  get(){
    this.load = true
    this.CarService.get().subscribe(
      (res: any) => {
        this.load = false
        this.error = false
        this.data = res
        // console.log('data', res)
      },
      (error: any) => {
        this.load = false
        this.error = true
        console.log('data', error)

      }
    )
  }

  getMarks(){
    this.loadMark = true
    this.MarksService.get().subscribe(
      (res: any) => {
        this.loadMark = false
        this.marks = res
        // console.log('data', res)
      },
      (error: any) => {
        this.loadMark = false
        console.log('data', error)
      }
    )
  }

  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.data, event.previousIndex, event.currentIndex);

    // Update positions after reordering
    this.data = this.data.map((item, index) => ({
      ...item,
      position: index + 1
    }));

    // Optionally, send updated positions to backend:
    // this.CarService.updatePositions(this.data).subscribe();
    this.loadUpdate = true
    this.CarService.updatePositions(this.data).subscribe(
      (res: any) => {
        this.loadUpdate = false
        this.ToastrService.success('პოზიცია წარმატებით განახლდა')
      // console.log('Positions updated!');
    },
    (error: any) => {
      this.loadUpdate = false
      this.ToastrService.error('მოხდა შეცდომა პოზიციის განახლების დროს')

      // console.log(error)
    });

  }

  add(){
    this.selected = null;
    this.isEdit = false
    this.form.reset({
      id: null,
      name: null,
      image: null,
      markid: null
  });
    this.modalService.open(this.formModalTemplate, { size: 'lg' });
  }

  edit(item: any){
    this.selected = item;
    this.isEdit = true
    console.log(item)
    this.form.patchValue({
      id: item.id || null,
      name: item.name || null,
      image: item.image || null,
      markid: item.markid || null,

    });
    this.modalService.open(this.formModalTemplate, { size: 'lg' })
  }

  onFileUploaded(fileName: string) {
    this.form.patchValue({ image: fileName });
  }

  save(modal: any){
    console.log(this.form.value)
    if(this.isEdit){
      this.loadSave = true
      this.CarService.update(this.form.value).subscribe(
        (res: any) => {
          this.load = false
          this.ToastrService.success('წარმატებით შეინახა')
          this.get()
          modal.close();
        },
        (error: any) => {
          this.load = false
          this.ToastrService.error('მოხდა შეცდომა, სცადეთ მოგვიანებით')
        }
      )
    }else {
      this.loadSave = true
      this.CarService.add(this.form.value).subscribe(
        (res: any) => {
          this.load = false
          this.ToastrService.success('წარმატებით დაემატა')
          this.get()
          modal.close();
        },
        (error: any) => {
          this.load = false
          this.ToastrService.error('მოხდა შეცდომა, სცადეთ მოგვიანებით')
        }
      )
    }
   

  }

  destroy(items: any){
    if(confirm('ნამდვილათ გსურთ წაშლა')){
      this.CarService.delete(items.id).subscribe(
        (res: any) => {
          this.get()
          this.ToastrService.success('წარმატებით წაიშალა')
        },
        (error: any) => {
          this.ToastrService.error('მოხდა შეცდომა, სცადეთ მოგვიანებით')
        }
      )
    }
    
  }
}

